// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__2OQvc","title":"NotFound_title__0ojqf","message":"NotFound_message__L5E9X","link":"NotFound_link__4-XmH"};